export interface WarningMessage {
    id: number
    i18nLocale: string
    message: string | null
}

export interface NetworkDataFromDetail {
    id: number
    name: string
    warningMessages: WarningMessage[] | []
    totalPoolsCount: number
    totalStationsCount: number
    totalEvsesCount: number
    isChargemapPassCompatible: boolean
    initialCenterLatitude: number
    initialCenterLongitude: number
}

export interface Statistics {
    id: number
    feedbacksCount: number
    checkinsCount: number
    reportsCount: number
    commentsCount: number
    ratingsCount: number
    globalNoteAverage?: number | null
    materialNoteAverage?: number | null
    priceNoteAverage?: number | null
    locationNoteAverage?: number | null
    securityNoteAverage?: number | null
    creationDate: string
    networkId: number
}

export enum StoreName {
    AppStore = 'apple',
    GooglePlay = 'google'
}

export interface NetworkDataFromListing {
    id: number
    name: string
    slug: string
    url: string | null
    rating: number | null
    remoteChargeHelpdocUrl: string | null
    contactId: number
    isHandledByChargemap: boolean
    iconUrl?: string | null
}
